var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.intervals,"chips":"","small-chips":"","item-text":"name","item-value":"id","label":_vm.$trans('v2.fm2.report.field.interval')},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }